// 处理大数字精度问题
// 详情见 https://github.com/nefe/number-precision
import Vue from 'vue'
import np from 'number-precision'

Vue.prototype.$NP = np
